import { computed, type ComputedRef } from 'vue'

import store from '../index'

export const useMappedGetter = <T>(accessor: string): ComputedRef<T> => {
  return computed(() => {
    return store.getters[accessor]
  })
}
